// extracted by mini-css-extract-plugin
export default {"page-content":"x2XZO","page-content-zero-padding":"WTPR2"};